import styled from '@emotion/styled';
import CarouselFeed from '@comp/CircularCarousel/CircularCarousel';
import { Spacings, mediaQuery } from '@styles/index';

const StyCarouselFeed = styled(CarouselFeed)`
  margin-bottom: 0px !important;
`;

const Container = styled.div`
  width: 100%;
  --layout-width: 1136px;
  --layout-mweb-width: 328px;
  margin-top: ${Spacings.SPACING_12B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_4B};
  }
`;

const OfflineCarousel = ({ data }) => {
  return (
    <Container>
      <StyCarouselFeed data={data} />
    </Container>
  );
};

export default OfflineCarousel;
